
import ProductCard from '@/components/Products/ProductCardV2.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    ProductCard,
    ProductCardVerticalImage: () =>
      import('@/components/Products/ProductCardVerticalImage.vue'),
  },
  computed: {
    ...mapGetters({
      getPopularProducts: 'popularProducts/getPopularProducts',
    }),
    Contents() {
      return this.$store.state.settings.contents
    },
    ProductCardComponent() {
      const productCardComponent = this.Contents.componentSettings.find(
        (c) => c.title === 'ProductCard'
      )
      if (!productCardComponent) return 'ProductCard'
      else return productCardComponent.description
    },
  },
}
